// As of 2021-06-04, this is a LEGACY method of detecting the current
// environment which uses nginx run-time variable injection. This should only be
// used with the Checkout widget since only its nginx containers inject the
// **GSG_ENVIRONMENT_LEGACY** variable at runtime. Once every site using the
// Checkout widget starts explicitly passing the environment as an attach
// parameter, this injection method can be removed and this file deleted.
//
// For the correct way to set up environment handling for new widgets/sites, see
// the Environment Handling section of:
// https://support.grantstreet.com/wiki/display/TECH/Front-End+Best+Practices
//
// -----------------------------------------------------------------------------
//
// This file exports a global GSG_ENVIRONMENT_LEGACY string that specifies which
// environment the current app/widget is being served from (this also includes
// some other env-based helpers). This environment will be one of the supported
// PSC environments:
//   - test
//   - beta
//   - stage
//   - demo
//   - prod
//
// Avoid doing URL matching to determine the environment - that is not scalable
// when our widgets are embedded on arbitrary sites.
//

// A boolean which is true if we are running in a local, Netlify, or
// pexdev/pexdas sandbox. This can be used to load resources from relative paths
// instead of fully-qualified govhub.com URLs for the sake of sandbox-testing
// those resources.
export const isSandbox = process.env.NODE_ENV === 'development' ||
    /netlify\.(app|com)/.test(window.location.hostname) ||
    /(das|dev)\d+.*\.grantstreet.com/.test(window.location.hostname) ||
    (
      // Also match Docker sandbox hostnames (e.g., "psc-widgets-ssl")
      !/\./.test(window.location.hostname) &&
      window.location.hostname.endsWith('-ssl')
    )

// A string of the environment this app/widget is being served from
export const GSG_ENVIRONMENT_LEGACY = (function () {
  // Local sandboxes use 'test'
  if (process.env.NODE_ENV === 'development') {
    return 'test'
  }
  // Other sandboxes (Netlify) use 'beta'. This is the one case where we do an
  // explicit URL check because 1) we don't always do a separate Netlify build
  // (so we can't use a VUE_APP_NETLIFY environment variable) and 2) Netlify
  // can't do nginx sub_filtering to replace GSG_ENVIRONMENT_LEGACY like nginx
  // can.
  else if (isSandbox) {
    return 'beta'
  }
  // Otherwise we use the environment where nginx is deployed
  else {
    // nginx will replace this string with the current environment:
    const env = '**GSG_ENVIRONMENT_LEGACY**'

    // Make sure GSG_ENVIRONMENT_LEGACY was injected by nginx correctly
    if (/GSG_ENVIRONMENT_LEGACY/.test(env)) {
      console.error('GSG_ENVIRONMENT_LEGACY was not injected')
    }

    return env
  }
})()
